import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { ChevronDown } from 'lucide-react';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  const [showTerms, setShowTerms] = useState(false);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-black font-body text-gray-100 selection:bg-matrix-green/30 selection:text-matrix-green overflow-x-hidden" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2032803920615657&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <OfferSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>

      <footer className="bg-black border-t border-matrix-green/20 py-8 px-4" data-id="element-12">
        <div className="max-w-3xl mx-auto" data-id="element-13">
          <p className="font-body text-matrix-green/50 text-sm text-center" data-id="element-14">
            &copy; {new Date().getFullYear()} PromptAdsPro. Todos los derechos
            reservados.
          </p>

          <div className="mt-4" data-id="element-15">
            <button onClick={() => setShowTerms(!showTerms)} className="mx-auto flex items-center gap-1.5 text-matrix-green/40 hover:text-matrix-green/70 text-xs font-body transition-colors" data-id="element-16">
              Términos y Condiciones
              <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-300 ${showTerms ? 'rotate-180' : ''}`} data-id="element-17" />
            </button>

            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${showTerms ? 'max-h-[600px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-18">
              <div className="bg-white/5 border border-matrix-green/10 rounded-lg p-5 text-gray-400 text-xs font-body leading-relaxed space-y-3" data-id="element-19">
                <p data-id="element-20">
                  <strong className="text-gray-300" data-id="element-21">
                    1. Uso del producto:
                  </strong>{' '}
                  PromptAdsPro es un software digital de uso personal. Al
                  adquirirlo, obtenés una licencia de uso individual e
                  intransferible.
                </p>
                <p data-id="element-22">
                  <strong className="text-gray-300" data-id="element-23">
                    2. Política de reembolso:
                  </strong>{' '}
                  Ofrecemos una garantía de satisfacción de 14 días. Si no estás
                  conforme, podés solicitar el reembolso completo dentro de ese
                  plazo.
                </p>
                <p data-id="element-24">
                  <strong className="text-gray-300" data-id="element-25">
                    3. Propiedad intelectual:
                  </strong>{' '}
                  Todo el contenido, diseño y funcionalidad del software es
                  propiedad exclusiva de PromptAdsPro. Queda prohibida su
                  reproducción o distribución sin autorización.
                </p>
                <p data-id="element-26">
                  <strong className="text-gray-300" data-id="element-27">
                    4. Limitación de responsabilidad:
                  </strong>{' '}
                  Los resultados obtenidos con el software dependen del uso
                  individual. No garantizamos resultados específicos en campañas
                  publicitarias.
                </p>
                <p data-id="element-28">
                  <strong className="text-gray-300" data-id="element-29">5. Modificaciones:</strong>{' '}
                  Nos reservamos el derecho de actualizar estos términos en
                  cualquier momento. Las actualizaciones serán comunicadas
                  oportunamente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}